module.exports = __webpack_public_path__ + "img/w3_search_white.23bf7bc1.png";